import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/v2/icons/Profile-Icon.png")